import { jsx as _jsx } from "react/jsx-runtime";
import { HoursEditor } from './HoursEditor';
export const FillHours = (props) => _jsx(HoursEditor, { ...props, mode: 'week' });
